// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminItem_container__3ys3J","item":"AdminItem_item__32_ss","removeBtn":"AdminItem_removeBtn__8wJ_L"};